<div class="host-details position-relative">
  <app-loader *ngIf="isLoading"></app-loader>
  <div class="host-details-container">
    <i yp-e2e-id="host-details-no-image" class="far fa-user-circle" *ngIf="isSellerDoingViewings"></i>
    <img yp-e2e-id="host-details-agent-image"
         [src]="hostAvatar ? hostAvatar : 'assets/images/icons/no-thumbnail.svg'"
         alt=""
         *ngIf="!isSellerDoingViewings"/>
    <div class="host-details-container-details">
      <h3 class="text-with-category-title" yp-e2e-id="host-details-name">
        <span>{{hostTitle()}}</span> {{hostDetails?.name}}</h3>
      <ul>
        <li><a (click)="copyToClipboard(hostDetails?.phone)" yp-e2e-id="host-details-phone">{{hostDetails?.phone}}</a></li>
        <li><a (click)="copyToClipboard(hostDetails?.email)" yp-e2e-id="host-details-email">{{hostDetails?.email}}</a></li>
      </ul>
    </div>
  </div>
  <a [href]="goToProfileLogic()" target="_blank" class="host-details-container">
    <img yp-e2e-id="host-details-alt-agent-image"
         [src]="alternativeAvatar ? alternativeAvatar : 'assets/images/icons/no-thumbnail.svg'"
         alt=""
         *ngIf="isSellerDoingViewings"/>
    <i yp-e2e-id="host-details-alt-no-image" class="far fa-user-circle" *ngIf="!isSellerDoingViewings"></i>
    <h3 class="text-with-category-title" yp-e2e-id="host-details-alt-name">
      <span>{{alternativeTitle()}}</span> {{alternativeDetails?.name}}</h3>
    <span class="host-details-external-link"><i class="fas fa-angle-right"></i></span>
  </a>
</div>
